import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { defaultValueFromHandlerName } from '@next-adapter/generators/form/form-shared/default-value-from-handler-name.js'

export function defaultValueFromSourceHandler(
  field: SchemaField,
  context: FieldRenderContext
): string | null {
  if (!context.defaultValueFromSourceNames?.has(field.name)) return null
  return defaultValueFromHandlerName(field.name)
}
